"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiftlineWebhookEventTransport = exports.LiftlineWebhookEventTypes = exports.LIFTLINE_EVENT_LOAN_UPDATED = exports.LIFTLINE_EVENT_INVOICE_CREATED = exports.LIFTLINE_EVENT_SELLER_CREATED = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.LIFTLINE_EVENT_SELLER_CREATED = 'seller.created';
exports.LIFTLINE_EVENT_INVOICE_CREATED = 'invoice.created';
exports.LIFTLINE_EVENT_LOAN_UPDATED = 'loan.updated';
exports.LiftlineWebhookEventTypes = [
    exports.LIFTLINE_EVENT_SELLER_CREATED,
    exports.LIFTLINE_EVENT_INVOICE_CREATED,
    exports.LIFTLINE_EVENT_LOAN_UPDATED,
];
// Liftline webhook envelope. The `data` field carries the full resource for the event type
// (matches `GET /sellers/{id}` for seller.created, `GET /invoices/{id}` for invoice.created,
// Loan object as nested in Invoice.loans[] for loan.updated). We accept `Type.Unknown()` here
// so route schema validation focuses on the envelope shape; each service narrows `data` as needed.
exports.LiftlineWebhookEventTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    type: typebox_1.Type.Union(exports.LiftlineWebhookEventTypes.map((eventType) => typebox_1.Type.Literal(eventType))),
    created_at: typebox_1.Type.String(),
    data: typebox_1.Type.Unknown(),
});
//# sourceMappingURL=event-envelope.js.map